import { StrictRouteConfig } from "@/router/router";
import Auth from "@okta/okta-vue";

export const authRoutes: StrictRouteConfig[] = [
    {
        path: "/login",
        name: "login",
        component: () => import(/* webpackChunkName: "auth" */ "@/views/auth/login.vue"),
        meta: {
            requiresAuth: false,
            label: "Login",
            includeInNavigation: false,
            hideNavbar: true,
        },
    },
    {
        path: "/okta-debug",
        name: "okta",
        component: () => import(/* webpackChunkName: "auth" */ "@/views/misc/okta.vue"),
        meta: {
            requiresAuth: true,
            label: "Okta debug",
            includeInNavigation: false,
            icon: "shield-key-outline",
        },
    },
    {
        path: "/okta-callback",
        name: "Okta callback",
        component: () => import(/* webpackChunkName: "auth" */ "@/views/auth/okta-callback.vue"),
        meta: {
            label: "Logging you in..",
            hideNavbar: true,
        },
    },
    {
        path: "/activated",
        name: "Account activated",
        component: () => import(/* webpackChunkName: "auth" */ "@/views/auth/activated.vue"),
        meta: {
            label: "Account activated",
            hideNavbar: true,
        },
    },
];
